
const { Core, Utils } = Global;
const { $active } = Utils;

customElements.define('accordion-with-images', class extends Core {
    elements = {
        $: [['thumbnail'], ['image']]
    };

    render() {
        this.activeImage = null;

        this.$('thumbnail', {
            click: this._handleThumbnailClick
        });

        const initiallyOpen = this.$('thumbnail')
            .findIndex(el => el.open);

        if (initiallyOpen >= 0) {
            this._setActiveImage(initiallyOpen);
        }
    }

    _handleThumbnailClick(e) {
        const details = e.currentTarget;

        if (details.open) {
            this._setActiveImage(null);
        } else {
            this._setActiveImage(
                Number(details.dataset.thumbIndex)
            );
        }
    }

    _setActiveImage(index) {
        if (this.activeImage) {
            $active(this.activeImage, false);
        }

        this.activeImage = index === null
            ? null
            : this.$('image').at(index);

        if (this.activeImage) {
            $active(this.activeImage);
        }
    }
});
